import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthInfo, LOGIN_MESSAGES } from './auth.utils';

export interface GenericAuthService {
  loginUrl: string;
  logoutUrl: string;
  loginMessageDict: typeof LOGIN_MESSAGES;

  authInfo$: Observable<AuthInfo>;
  authInfo: AuthInfo | undefined;

  customerSlug$: Observable<string | null>;
  customerSlug: string | null;

  sessionUuid$: Observable<string | null>;
  sessionUuid: string | null;

  login(username: string, password: string, errorCallback: (error: null | unknown, result: unknown) => void): void;

  logout(
    logoutMessageCode?: keyof typeof LOGIN_MESSAGES | string,
    customMessage?: string,
    federated?: boolean,
    returnToLoginPage?: boolean,
    clearAllLocalStorage?: boolean,
  ): void;

  authorize(connection: string): void;

  getToken(options?: {
    authorizationParams?: {
      scope?: string;
      audience?: string;
    };
  }): Observable<string>;

  renewTokenIfStale(staleAge?: number): void;

  renewToken(): void;

  popRedirectUrl(): string | null;

  getRedirectUrl(): string | null;

  crossOriginVerification(): void;

  resetPasswordRequest(
    params: {
      connection: string;
      email: string;
    },
    callback: (error: null | unknown, result: unknown) => void,
  ): void;

  setSessionUuid(sessionUuid: string): void;
  setCustomerSlug(customerSlug: string): void;
  removeCustomerSlug(): void;

  overrideToken(authInfo: AuthInfo): void;
  trySetRedirectBackUrl(url?: string): void;
}

export const GENERIC_AUTH_SERVICE_TOKEN = new InjectionToken<GenericAuthService>('GenericAuthService');
